import type { NewProduct } from '@/store/pos';

/**
 * ແມ່ແບບເຄື່ອງກໍ່ສ້າງ — the common items a Lao construction-material shop carries,
 * with typical units and prices. Onboarding path A: the owner ticks what they
 * stock instead of typing a catalog from scratch.
 */
export const PRESET_TEMPLATES: { cat: string; items: NewProduct[] }[] = [
  {
    cat: 'ຊີມັງ',
    items: [
      { name: 'ຊີມັງ ຕີໂກ້', cat: 'ຊີມັງ', unit: 'ຖົງ', price: 55000 },
      { name: 'ຊີມັງ ອິນຊີ', cat: 'ຊີມັງ', unit: 'ຖົງ', price: 58000 },
      { name: 'ຊີມັງຂາວ', cat: 'ຊີມັງ', unit: 'ຖົງ', price: 72000 },
    ],
  },
  {
    cat: 'ເຫຼັກ',
    items: [
      { name: 'ເຫຼັກເສັ້ນ 9mm', cat: 'ເຫຼັກ', unit: 'ເສັ້ນ', price: 32000 },
      { name: 'ເຫຼັກເສັ້ນ 12mm', cat: 'ເຫຼັກ', unit: 'ເສັ້ນ', price: 45000 },
      { name: 'ເຫຼັກກ່ອງ 2×2', cat: 'ເຫຼັກ', unit: 'ເສັ້ນ', price: 68000 },
      { name: 'ລວດຜູກເຫຼັກ', cat: 'ເຫຼັກ', unit: 'ກິໂລ', price: 18000 },
    ],
  },
  {
    cat: 'ຊາຍ/ຫີນ',
    items: [
      { name: 'ດິນຊາຍ', cat: 'ຊາຍ/ຫີນ', unit: 'ຄິວ', price: 90000 },
      { name: 'ຫີນແມ່ນ້ຳ', cat: 'ຊາຍ/ຫີນ', unit: 'ຄິວ', price: 110000 },
      { name: 'ຫີນຝຸ່ນ', cat: 'ຊາຍ/ຫີນ', unit: 'ຄິວ', price: 85000 },
    ],
  },
  {
    cat: 'ທໍ່',
    items: [
      { name: 'ທໍ່ PVC 2 ນິ້ວ', cat: 'ທໍ່', unit: 'ເສັ້ນ', price: 26000 },
      { name: 'ທໍ່ PVC 3 ນິ້ວ', cat: 'ທໍ່', unit: 'ເສັ້ນ', price: 38000 },
      { name: 'ຂໍ້ຕໍ່ PVC', cat: 'ທໍ່', unit: 'ອັນ', price: 6000 },
    ],
  },
];

/** Units offered in the rapid-entry row, ordered by how often they are used. */
export const UNIT_OPTIONS = ['ຖົງ', 'ເສັ້ນ', 'ຄິວ', 'ໂຕນ', 'ອັນ', 'ກິໂລ'];
